export default __webpack_public_path__ + "static/Origin-d4e36449496651bc264343b84831086d.mp3";